﻿define([
    'log',
    'knockout',
    '../libs/knockout.mapping-latest.debug',
    '../libs/knockout-kendo',
    '../build/utils/knockout.bindings'
], function (log, ko, mapping/*, validation*/) {
    log.log('Knockout extensions loaded.');
    // Augment knockout with mapping and validation:
    ko.mapping = mapping;
    //ko.validation = validation;
});


//////////////////
// WEBPACK FOOTER
// ./shim/knockoutplugins.js
// module id = 34
// module chunks = 2